import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleError } from '../../../../../shared/ErrorCatching';
import { Translate } from '../../../../../shared/LanguageService';
import * as Actions from '../Actions';
import { BookableOrderTypes, IBasicOrderInfo, OrderTypes } from '../Types';

type UseUnbookingProps = {
    order: IBasicOrderInfo;
    user: any;
    history: any;
    reloadOrder: () => void;
    showSuccess: (text: string) => void;
    showFailure: (text: string) => void;
};

export function useUnbooking(props: UseUnbookingProps) {
    const { order, user, history, reloadOrder, showSuccess, showFailure } = props;
    const dispatch = useDispatch<any>();

    const [showUnbookingModal, setShowUnbookingModal] = useState(false);
    const [unbookingModalMessage, setUnbookingModalMessage] = useState('');

    const onPhotographerUnbooked = (): void => {
        reloadOrder();
    };

    const onStylingUserUnbooked = (): void => {
        if (user.details.role === 'role/styling-admin') {
            history.push('/stylingcalendars');
        } else {
            reloadOrder();
        }
    };

    const performUnbooking = (): void => {
        order.bookingInfo.bookableOrderType.value === BookableOrderTypes.Photo &&
            dispatch(Actions.unbookPhotographer(order.bookingInfo.calendarItemId))
                .then((response: any) => {
                    if (response.success) {
                        showSuccess(
                            Translate('view-order/basic-order-info/toastr/unbook-successful')
                        );
                        onPhotographerUnbooked();
                    } else {
                        showFailure(Translate('view-order/basic-order-info/toastr/unbook-error'));
                    }
                })
                .catch((error: any) => {
                    handleError(error);
                });

        order.bookingInfo.bookableOrderType.value === BookableOrderTypes.Styling &&
            dispatch(Actions.unbookStylingUser(order.bookingInfo.calendarItemId))
                .then(() => {
                    showSuccess(
                        Translate('view-order/basic-order-info/toastr/unbook-successful-stylist')
                    );
                    onStylingUserUnbooked();
                })
                .catch((error: any) => {
                    handleError(error);
                });
    };

    const toggleUnbookingModal = (bookingCancellationType: number = 0): void => {
        let message = '';
        if (bookingCancellationType === 1) {
            message = Translate('view-order/basic-order-info/unbook/modal/message/late');
        } else if (bookingCancellationType === 2) {
            message = Translate('view-order/basic-order-info/unbook/modal/message/sameday');
        } else if (bookingCancellationType === 3) {
            message = Translate('view-order/basic-order-info/unbook/modal/message/sameday');
        }

        setShowUnbookingModal(!showUnbookingModal);
        setUnbookingModalMessage(message);
    };

    const unbookPhotographer = (): void => {
        if ((order.orderType & OrderTypes.photo) > 0) {
            Actions.preCheckUnbooking(order.bookingInfo.calendarItemId)
                .then((result: any) => {
                    if (result.bookingCancellationType === 0) {
                        performUnbooking();
                    } else {
                        toggleUnbookingModal(result.bookingCancellationType);
                    }
                })
                .catch((error: any) => {
                    handleError(error);
                });
        } else {
            performUnbooking();
        }
    };

    return {
        showUnbookingModal,
        unbookingModalMessage,
        unbookPhotographer,
        performUnbooking,
        toggleUnbookingModal
    };
}
